import _ from 'lodash';
import {
  CLEAR_CONTINUE_WATCHING_CTA,
  FETCH_ACTIVE_PLAN_PACKAGES,
  FETCH_CONTINUE_WATCHING_CTA,
  SET_FREEMIUM_MODAL_VISIBILITY,
  SET_MVPD_PROVIDERS,
  SET_NEXT_MVPD_PROVIDERS_PAGE,
  SET_PREAUTHORIZED_RESOURCES,
  SET_RECOMMENDATION_ID,
  SET_USER_AUTH_DATA,
  SET_USER_SUBSCRIPTION,
  REFRESH_USER_AUTH,
} from './AppActions';

const INITIAL_STATE = {
  account: null,
  activePlans: null,
  anonymousAccount: null,
  anonymousId: null,
  auth: null,
  authorizationToken: null,
  buythroughScenario: null,
  dataDogSendLogs: null,
  deviceId: null,
  freemiumModalVisibility: false,
  freemiumRedirectUrl: null,
  isAuthenticated: false,
  mvpd: null,
  mvpdProviders: null,
  pcs: {},
  preauthorizedResources: null,
  profile: null,
  profileBookmarks: null,
  profileFavorites: null,
  recommendationIdData: null,
  segmentDeviceId: null,
  subscription: null,
  subscriptionPaused: null,
  topMVPDProviders: null,
};

const PAUSED_STATUS = 'Pause';

const sorter = items => {
  if (!items || !items.length) return null;
  const newItems = items.map(item => {
    const copy = Object.assign({}, item);
    copy.nameLowercase = item.name ? item.name.toLowerCase() : null;
    return copy;
  });
  return _.sortBy(newItems, ['nameLowercase']);
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MVPD_PROVIDERS: {
      const member = _.get(action, 'payload.data.member');
      const mvpdProviders = sorter(member);
      let totalProviders = 0;
      const maxProviders = 10;
      const topMVPDProviders = mvpdProviders.filter(provider => {
        if (totalProviders > maxProviders) return false;
        if (provider.isFeatured) {
          totalProviders += 1;
          return true;
        }
        return false;
      });

      return {
        ...state,
        mvpdProviders,
        topMVPDProviders,
      };
    }
    case SET_NEXT_MVPD_PROVIDERS_PAGE: {
      const mvpds = _.get(state, 'mvpdProviders');
      let member = _.get(action, 'payload.data.member');
      member = [...mvpds, ...member];
      member = [...new Set(member)]; // Dedupe MVPDs
      const mvpdProviders = sorter(member);
      let totalProviders = 0;
      const maxProviders = 10;
      const topMVPDProviders = mvpdProviders.filter(provider => {
        if (totalProviders > maxProviders) return false;
        if (provider.isFeatured) {
          totalProviders += 1;
          return true;
        }
        return false;
      });

      return {
        ...state,
        mvpdProviders,
        topMVPDProviders,
      };
    }
    case SET_PREAUTHORIZED_RESOURCES: {
      return {
        ...state,
        preauthorizedResources: action.payload,
      };
    }
    case SET_RECOMMENDATION_ID: {
      return {
        ...state,
        recommendationIdData: action.payload,
      };
    }
    case CLEAR_CONTINUE_WATCHING_CTA: {
      return {
        ...state,
        continueWatchingData: {},
      };
    }
    case SET_USER_AUTH_DATA: {
      const data = action.payload;
      if (!data) return state;

      /*
      data may include any or all of the following:
        account,
        anonymousAccount,
        anonymousId,
        authorizationToken,
        buythroughScenario,
        deviceId,
        isAuthenticated,
        mvpd,
        preauthorizedResources,
        dataDogSendLogs,
        segmentDeviceId,
      */

      return {
        ...state,
        ...data,
      };
    }
    case REFRESH_USER_AUTH: {
      const data = action.payload;
      const { account, anonymousAccount, mvpd: prevMVPD } = state;
      const mvpd = data?.mvpd ?? prevMVPD;
      const isAnonymous = !account;

      const newState = {
        ...state,
        account: !isAnonymous ? { ...account, ...data } : null,
        anonymousAccount: isAnonymous ? { ...anonymousAccount, ...data } : null,
        authorizationToken: data.accessToken,
        mvpd,
      };
      return newState;
    }
    case SET_FREEMIUM_MODAL_VISIBILITY: {
      const { visibility, redirectUrl = null } = action.payload;
      return {
        ...state,
        freemiumModalVisibility: visibility,
        freemiumRedirectUrl: redirectUrl,
      };
    }
    case SET_USER_SUBSCRIPTION: {
      const status = action?.payload?.data[0]?.status;
      const subscription = action?.payload?.data[0];

      return {
        ...state,
        subscriptionPaused: status === PAUSED_STATUS,
        subscription,
      };
    }
    case FETCH_CONTINUE_WATCHING_CTA: {
      const { data } = action.payload;
      const continueWatchingData = data?.panels?.member?.[0]?.items?.member?.[0];
      return {
        ...state,
        continueWatchingData,
      };
    }
    case FETCH_ACTIVE_PLAN_PACKAGES: {
      const { data } = action.payload;
      return {
        ...state,
        activePlans: data || {},
      };
    }
    default:
      return state;
  }
}
